import React from 'react';
import { AccordionLayout } from 'v2/common/Activity/AssociationsLayout';
import styles from './nomadGuidance.module.scss';
import { ProposalEntity } from 'v2/models';
import { isWaitingForSellerProposal } from 'v2/utils/proposalUtils';

interface INomadGuidance {
  proposal: ProposalEntity;
}

const NomadGuidance = ({ proposal }: INomadGuidance) => {
  if (!isWaitingForSellerProposal(proposal) || !proposal.nomad_guidance) {
    return null;
  }

  const renderContent = () => {
    return <div className={styles.content}>{proposal.nomad_guidance}</div>;
  };

  return (
    <AccordionLayout
      header={'Why was my organization matched to this Request?'}
      customStyle={styles}
      content={renderContent()}
    />
  );
};

export default NomadGuidance;
